module.exports = __webpack_public_path__ + "static/media/PM101.ac084154.png";